import { SubmitHandler } from "react-hook-form";

import {
    IClubhouseTeamTryoutData,
    TryoutsHandlersProps,
} from "../types/tryouts";

import { alertActions } from "../../../../../features/alert/alertSlice";
import { selectSelectedTeam } from "../../../../../features/clubhouse/clubhouseSlice";
import {
    useAppDispatch,
    useAppSelector,
} from "../../../../../hooks/reduxHooks";
import { deleteTryouts, updateTryouts } from "../../../../../lib/api";

const useTryoutsHandlers = ({
    setShow,
    setSending,
    setTryout,
    setTryoutList,
    methods,
}: TryoutsHandlersProps) => {
    const dispatch = useAppDispatch();
    const selectedTeam = useAppSelector(selectSelectedTeam);
    const { user } = useAppSelector(state => state.auth);

    const handleSubmit: SubmitHandler<
        IClubhouseTeamTryoutData
    > = async data => {
        setSending(true);
        try {
            const { tryouts } = await updateTryouts(data, selectedTeam!.id);

            dispatch(
                alertActions.success({
                    title: "Tryouts updated successfully",
                    dismissible: true,
                }),
            );

            setTryout(tryouts.find(t => t.id === selectedTeam?.id));

            if (setTryoutList) {
                setTryoutList(tryouts);
            }
        } catch (error: any) {
            dispatch(
                alertActions.error({
                    title: "The was a problem submitting the tryout request.",
                    text: error,
                    dismissible: true,
                }),
            );
        } finally {
            setSending(false);
        }
    };

    const handleDelete: React.MouseEventHandler<
        HTMLButtonElement
    > = async () => {
        setSending(true);
        setShow(false);
        try {
            const { tryouts } = await deleteTryouts(selectedTeam!.id, user!.id);

            dispatch(
                alertActions.success({
                    title: "Tryout info deleted successfully",
                    dismissible: true,
                }),
            );

            setTryout(undefined);
            methods.reset(undefined);

            if (setTryoutList) {
                setTryoutList(tryouts);
            }
        } catch (error: any) {
            dispatch(
                alertActions.error({
                    title: "The was a problem deleting the tryout info.",
                    text: error,
                    dismissible: true,
                }),
            );
        } finally {
            setSending(false);
        }
    };
    return { handleSubmit, handleDelete };
};

export default useTryoutsHandlers;
